export default "__VITE_ASSET__762f657e__"